export default __webpack_public_path__ + "static/media/tech-blog.a42050ab.png";